import { render, staticRenderFns } from "./copyLinkToForm.vue?vue&type=template&id=7b8aacf4&scoped=true"
import script from "./copyLinkToForm.vue?vue&type=script&lang=js"
export * from "./copyLinkToForm.vue?vue&type=script&lang=js"
import style0 from "./copyLinkToForm.vue?vue&type=style&index=0&id=7b8aacf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8aacf4",
  null
  
)

export default component.exports